import { useEffect } from "react";

/**
 * Sets document.title and meta description for the current page.
 * Restores previous title on unmount so subsequent pages start fresh.
 * Falls back to global site title (from useBranding) if title is falsy.
 */
export default function usePageMeta(title, description) {
  useEffect(() => {
    if (!title) return;
    document.title = title;
    if (description) {
      let metaEl = document.querySelector('meta[name="description"]');
      if (!metaEl) {
        metaEl = document.createElement("meta");
        metaEl.setAttribute("name", "description");
        document.head.appendChild(metaEl);
      }
      metaEl.setAttribute("content", description);
    }
    // No cleanup — the next page's usePageMeta will overwrite. This avoids ordering issues
    // during client-side route transitions in React.
  }, [title, description]);
}
